export const PREPARE_COMBINE_CUSTOMERS_MODAL_OPEN = 'PREPARE_COMBINE_CUSTOMERS_MODAL_OPEN';
export const COMBINE_CUSTOMERS_MODAL_OPEN = 'COMBINE_CUSTOMERS_MODAL_OPEN';
export const PREPARE_COMBINE_CUSTOMERS_CONFIRMATION_MODAL_OPEN = 'PREPARE_COMBINE_CUSTOMERS_CONFIRMATION_MODAL_OPEN';
export const COMBINE_CUSTOMERS_CONFIRMATION_MODAL_OPEN = 'COMBINE_CUSTOMERS_CONFIRMATION_MODAL_OPEN';
export const COMBINE_CUSTOMERS_CONFIRMATION_MODAL_CLOSED = 'COMBINE_CUSTOMERS_CONFIRMATION_MODAL_CLOSED';
export const INITIATE_COMBINE_CUSTOMERS = 'INITIATE_COMBINE_CUSTOMERS';
export const REORDER_SELECTED_CUSTOMERS = 'REORDER_SELECTED_CUSTOMERS';

export const prepareToOpenCombineCustomersModal = () => {
  return {
    type: PREPARE_COMBINE_CUSTOMERS_MODAL_OPEN,
  };
};

export const openCombineCustomersModal = (modalId) => {
  return {
    type: COMBINE_CUSTOMERS_MODAL_OPEN,
    modalId,
  };
};

export const prepareToOpenCombineCustomersConfirmationModal = () => {
  return {
    type: PREPARE_COMBINE_CUSTOMERS_CONFIRMATION_MODAL_OPEN,
  };
};

export const openCombineCustomersConfirmationModal = (modalId) => {
  return {
    type: COMBINE_CUSTOMERS_CONFIRMATION_MODAL_OPEN,
    modalId,
  };
};

export const closeCombineCustomersConfirmationModal = () => {
  return {
    type: COMBINE_CUSTOMERS_CONFIRMATION_MODAL_CLOSED,
  };
};

export const combineCustomers = (selectedCustomerIds) => {
  return {
    type: INITIATE_COMBINE_CUSTOMERS,
    selectedCustomerIds,
  };
};

export const reorderCustomers = (sourceIndex, destinationIndex) => {
  return {
    type: REORDER_SELECTED_CUSTOMERS,
    sourceIndex,
    destinationIndex,
  };
};
